import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@honda-canada/design-system-react';
import VideoModalPlayer from './VideoModalPlayer';

const VideoModal = ({ source, videoType, ...props }) => (
  <Modal closeBtnStyling="circularWhite" styling="video" {...props}>
    {() => <VideoModalPlayer responsive source={source} videoType={videoType} />}
  </Modal>
);

VideoModal.propTypes = {
  source: PropTypes.string,
  videoType: PropTypes.string,
};

export default VideoModal;
